(() => {
  const dialog = document.querySelector('[data-artwork-dialog]');
  if (dialog) {
    let opener;
    document.querySelectorAll('[data-enlarge]').forEach(button => {
      button.addEventListener('click', () => {
        opener = button;
        const img = button.querySelector('img');
        const enlarged = dialog.querySelector('img');
        enlarged.src = button.dataset.full || img.currentSrc || img.src;
        enlarged.alt = img.alt;
        dialog.querySelector('p').textContent = button.dataset.caption;
        dialog.showModal();
        document.documentElement.classList.add('no-scroll');
      });
    });
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('no-scroll');
      opener?.focus();
    });
  }
  // Alternate-template links need their own view value; retain only the preview theme.
  const query = new URLSearchParams(window.location.search);
  const preview = query.get('preview_theme_id');
  if (preview && /^\d+$/.test(preview)) {
    document.querySelectorAll('a[data-preview-link]').forEach(a => {
      const url = new URL(a.href, window.location.origin);
      url.searchParams.set('preview_theme_id', preview);
      a.href = url.toString();
    });
  }
  document.querySelectorAll('audio, video').forEach(media => {
    media.addEventListener('play', () => {
      document.querySelectorAll('audio, video').forEach(other => { if (other !== media) other.pause(); });
    });
  });
})();
